import type { Action } from 'redux'

import { CHANGE_CHANNELS_TYPE } from './constants'
import type { ChannelsType } from './types'

interface ReducerAction extends Action {
  payload?: ChannelsType
}

export default function channelsType(state: ChannelsType = 'channels', { payload, type }: ReducerAction) {
  switch (type) {
    case CHANGE_CHANNELS_TYPE:
      return payload ? payload : state
    default:
      return state
  }
}
